import React, { Dispatch, SetStateAction } from "react";
import { Modal } from "antd";
import styled from "@emotion/styled";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import TitleNavigateButton from "@components/button/TitleNavigateButton";
import BasicButton from "@components/button/BasicButton";
import { useNavigate } from "react-router-dom";
import { useApiRequest } from "@utils/ApiRequest";
import { useQuery } from "@tanstack/react-query";

const ButtonWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "1.2rem",
  padding: "6rem 3.2rem 2rem",
  width: "100%",
});

const ImageWrapper = styled.div({
  display: "flex",
  width: "100%",
  height: "100%",

  flexShrink: 0,
});

const ImageBox = styled.div({
  position: "relative",
  width: "100%",
  aspectRatio: "335 / 370",
});

const ImageItem = styled.div({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  img: {
    width: "100%",
    height: "100%",

    objectPosition: "top",
  },
});

type Props = {
  children?: React.ReactNode;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
};
const LoginModalContainer = styled(Modal)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",

  ".ant-modal-content": {
    borderRadius: "0",
    padding: "0",
  },

  ".ant-modal-body": {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
  },
}));

const LoginModal = ({ children, open, setOpen }: Props) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const lang = window.localStorage.getItem("language");
  const { getPopup } = useApiRequest();

  const { data: popup, isLoading } = useQuery({
    queryKey: ["popup", lang],
    queryFn: getPopup,
  });

  const closeModal = () => {
    setOpen(false);
  };

  const handleNavigateJoinPage = () => {
    closeModal();
    navigate("/verify-email");
  };

  return (
    <LoginModalContainer
      open={open}
      footer={false}
      closeIcon={false}
      transitionName={""}
      maskTransitionName={""}>
      <ImageWrapper>
        {isLoading ? (
          <></>
        ) : (
          <ImageBox>
            <ImageItem>
              <Image
                src={
                  lang === "en" && popup?.thumbnail_url_en
                    ? popup?.thumbnail_url_en
                    : popup?.thumbnail_url_ko
                }
                width="100%"
                height="100%"
              />
            </ImageItem>
          </ImageBox>
        )}
      </ImageWrapper>
      <ButtonWrapper>
        <TitleNavigateButton
          title="로그인"
          route="/login"
          color={theme.color.gray}
          underline
        />

        <BasicButton
          title={"회원가입 후 시작하기"}
          onClick={handleNavigateJoinPage}
        />
        <BasicButton
          title={"게스트로 구경하기"}
          onClick={closeModal}
          outlined
        />
      </ButtonWrapper>
    </LoginModalContainer>
  );
};

export default LoginModal;
